module.exports = __webpack_public_path__ + "img/greater_crit.386bc6b2.png";